var PDFObject = /** @class */ (function () {
    function PDFObject() {
        var _this = this;
        this.clone = function () {
            throw new Error("clone() is not implemented on " + _this.constructor.name);
        };
        this.toString = function () {
            throw new Error("toString() is not implemented on " + _this.constructor.name);
        };
        this.bytesSize = function () {
            throw new Error("bytesSize() is not implemented on " + _this.constructor.name);
        };
        this.copyBytesInto = function (buffer) {
            throw new Error("copyBytesInto() is not implemented on " + _this.constructor.name);
        };
    }
    return PDFObject;
}());
export default PDFObject;
